import styled from 'styled-components';

const StyledSideRedHeading = styled.div`
  padding-left: 0.5rem;
  border-left: 5px solid #dc3b45;
`;

export function SideRedHeading({ children }) {
  return (
    <StyledSideRedHeading>
      <h2 className="text-primary">{children}</h2>
    </StyledSideRedHeading>
  );
}
